export default "__VITE_ASSET__BMpcHX_F__"